import {
    apiRequest,
    schedulerCreate, 
    schedulerUpdate
} from "../../../../../services/adapters/kepegawaian/schedulerService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", schedulerCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", schedulerUpdate, {
            body: query
        }, true)
    }

}

export default CreateRepository